import React, { useState, useRef } from "react";
import { SECONDS_IN_MINUTE } from "./constants.bids";
import "./BidsHelpModal.css";
import {
  Overlay,
  Sheet,
  SheetHandle,
  SheetTitle,
  SheetClose,
  AudioHint,
  AudioCard,
  AudioPlay,
  AudioWaveBar,
  AudioWaves,
  AudioDuration,
  StepsCard,
  StepRow,
  StepBubble,
  StepBubbleLabel,
  StepDesc,
  GotItBtn,
} from "./styles.bids";

const STEPS = [
  "Hyperpure requests a bid with product requirements and delivery details",
  "You submit your best pricing for the products before deadline",
  "Hyperpure evaluates all bids and awards the contract to the best offer",
];

const WAVE_HEIGHTS = [35, 55, 75, 90, 100, 85, 70, 60, 80, 95, 75, 50, 65, 88, 72, 58, 82, 68, 45, 78];

const BidsHelpModal = ({ isOpen, onClose, audioUrl }) => {
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  const fmt = (s) => `${Math.floor(s / SECONDS_IN_MINUTE)}:${String(Math.floor(s % SECONDS_IN_MINUTE)).padStart(2, "0")}`;

  const toggleAudio = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  if (!isOpen) return null;

  return (
    <Overlay onClick={onClose}>
      <Sheet onClick={(e) => e.stopPropagation()}>
        <SheetHandle />

        <div className="bids-help-modal-header">
          <SheetTitle>How do bids work</SheetTitle>
          <SheetClose onClick={onClose}>×</SheetClose>
        </div>

        <AudioCard>
          <AudioHint>
            <img src="/logos/bids_audio.png" width="14" height="16" alt="" />
            Listen audio for better understanding
          </AudioHint>

          <div className="bids-help-modal-audio-player">
            <AudioPlay $playing={playing} onClick={toggleAudio}>
              {playing ? (
                <svg width="14" height="16" viewBox="0 0 12 14" fill="none">
                  <rect x="1" y="1" width="3" height="12" rx="1" fill="#ef4f5f"/>
                  <rect x="8" y="1" width="3" height="12" rx="1" fill="#ef4f5f"/>
                </svg>
              ) : (
                <svg width="14" height="16" viewBox="0 0 12 14" fill="none">
                  <path d="M2 1l10 6-10 6V1z" fill="#ef4f5f"/>
                </svg>
              )}
            </AudioPlay>
            <AudioWaves>
              {WAVE_HEIGHTS.map((h, i) => (
                <AudioWaveBar key={i} height={h} active={playing && i < Math.floor((currentTime / (duration || 1)) * WAVE_HEIGHTS.length)} />
              ))}
            </AudioWaves>
            <AudioDuration>{duration > 0 ? `${fmt(currentTime)} / ${fmt(duration)}` : "0:00"}</AudioDuration>
            {audioUrl && (
              <audio
                ref={audioRef}
                src={audioUrl}
                preload="auto"
                onLoadedMetadata={e => setDuration(e.target.duration)}
                onTimeUpdate={e => setCurrentTime(e.target.currentTime)}
                onEnded={() => { setPlaying(false); setCurrentTime(0); }}
              />
            )}
          </div>
        </AudioCard>

        <StepsCard>
          {STEPS.map((text, i) => (
            <StepRow key={i}>
              <div className="bids-help-modal-step-index">
                <StepBubble>
                  <span>{i + 1}</span>
                  <StepBubbleLabel>Step</StepBubbleLabel>
                </StepBubble>
              </div>
              <StepDesc>{text}</StepDesc>
            </StepRow>
          ))}
        </StepsCard>

        <div className="bids-help-modal-footer">
          <GotItBtn onClick={onClose}>Got it</GotItBtn>
        </div>
      </Sheet>
    </Overlay>
  );
};

export default BidsHelpModal;
